import apiService from './apiService';

var servicePath = '/Groups';

function groups() {
	return apiService.get(servicePath);
}

export default {
	groups
};